export default __webpack_public_path__ + "static/media/WB_Boombox.be171914.gif";